<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div>
        <div v-if="objEdicao" class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo Referência</label>
                    <div class="field-label field-label-center">{{ objEdicao.ref_protocolo }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Protocolo RAC</label>
                    <div class="field-label field-label-center field-label--destaque">{{ objEdicao.protocolo }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Data/Hora RAC</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objEdicao.dhencerramento) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Status</label>
                    <div class="field-label">{{ objEdicao.nmstatus }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char40">
                    <label class="label-caption">SIM</label>
                    <div class="field-label field-label-start">{{ objEdicao.nmsim }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label-start">{{ objEdicao.nmestabelecimento }}</div>
                </div>
                <button type="button" class="btn-small" @click="closeForm">Voltar</button>
            </div>
        </div>
    </div>
    

    <div v-for="item in lsItens" :key="item.id" class="form-edit-page row-space">
        <div class="tela-dividida row-space">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Ítem</label>
                    <div class="field-label field-label--destaque">{{ item.ref_cditem }} - {{ item.ref_nmitem }}</div>
                </div>
            </div>

            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">Data Prevista</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.acdtprevista) }}</div>
                </div> 
            </div>
        </div>
        

        <div class="tela-dividida">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Não Conformidade</label>
                    <textarea v-model="item.ref_nc" rows="5" maxlength="3000" readonly/>
                </div>
            </div>

            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Ação Corretiva</label>
                    <textarea v-model="item.acdetalhamento" rows="5" maxlength="3000" readonly/>
                </div>
            </div>
        </div>
    </div>


    <div class="row-end">
        <button class="btn-cancel" @click="reabrirDigitacao">Reabrir Digitação</button>
        <button class="btn-confirm" @click="encerrarDigitacao">Encerrar e Assinar</button>
    </div>


    <ModalJustificativa ref="modalJustificativa" />

    
    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />


    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import ModalJustificativa from '@/components/modals/ModalJustificativa.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idAssinatura: {type: Number, default: 0},
    idRac: {type: Number, default: 0},
});
const modalJustificativa = ref(null);
const senhaModalRef = ref(null);

const isLoading = ref(false);
const lsItens = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref('Relatório encerrado e homologado com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref(null);
const showOkModal = ref(false);


const closeForm = () => {
    emit('save');
    emit('close'); 
}


async function encerrarDigitacao(){
    try{
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;
        
        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:RAC|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.protocolo}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'RAC';
        objAssinatura.value.acao = 'registroAssinaturaPendente';
        objAssinatura.value.acao_id = props.idAssinatura;

        const respAss = await Api.genericPut('/pla/assinar', objAssinatura.value);
        if (respAss.bolok === 1){
            showOkModal.value = true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;

        const r = await Api.genericPost('/dados/rac', {idep: globalStore.idep, id: props.idRac});
        objEdicao.value = r[0];

        if (objEdicao.value){
            const rItens = await Api.genericPost('/dados/rac_item', {idep: globalStore.idep, idreferencia: objEdicao.value.id});
            lsItens.value =  rItens;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function reabrirDigitacao(){
    const rModal = await modalJustificativa.value.show();

    if (!rModal.confirmado) return;

    try{
        isLoading.value=true;
        msgAlerta.value=null;

        const resp = await Api.genericPost('/rotinas/executar', {
            nmrequisicao: 'racReabrir',
            idep: globalStore.idep,
            idreferencia: objEdicao.value.id,
            idlogin: globalStore.idlogin,
            strpatam1: rModal.justificativa,
        });
        if (resp.bolok === 1){
            msgOkModal.value = 'RAC está reaberto para digitação!';
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${resp.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>

<style scoped>
.tela-dividida {
    display: flex;
    gap: 10px;
    box-sizing: border-box;
}

.coluna {
    flex: 1;
    display: flex;
    gap: 10px;
    align-items: end;
}

.esquerda {
    background-color: #3498db;
}

.direita {
    background-color: #2ecc71;
}
</style>
